import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Dashboard: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4">Dashboard</Typography>
      <Box mt={2}>
        <Typography color="text.secondary">
          Dashboard component - Full conversion needed
        </Typography>
      </Box>
    </Container>
  );
};

export default Dashboard;
